import React from 'react';
import { COLORS } from '../../utils/constants';

const GoogleSignInButton = ({ text = "Sign in with Google", onClick, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="google-signin-btn"
      style={{
        width: '100%',
        padding: '14px 24px',
        backgroundColor: COLORS.white,
        border: `2px solid ${COLORS.lightGray}`,
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        fontSize: '16px',
        fontWeight: '500',
        color: COLORS.black,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        fontFamily: 'inherit',
        opacity: disabled ? 0.6 : 1
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.borderColor = COLORS.blue;
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '';
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.borderColor = COLORS.lightGray;
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M19.8 10.2273C19.8 9.51818 19.7364 8.83636 19.6182 8.18182H10.2V12.05H15.5818C15.3364 13.3 14.5909 14.3591 13.4727 15.0682V17.5773H16.7727C18.6091 15.8364 19.8 13.2727 19.8 10.2273Z" fill="#4285F4"/>
        <path d="M10.2 20C12.9 20 15.1636 19.1045 16.7727 17.5773L13.4727 15.0682C12.5409 15.6682 11.3636 16.0227 10.2 16.0227C7.59545 16.0227 5.38636 14.2636 4.56364 11.9H1.16364V14.4909C2.76364 17.6591 6.24545 20 10.2 20Z" fill="#34A853"/>
        <path d="M4.56364 11.9C4.35455 11.3 4.23636 10.6591 4.23636 10C4.23636 9.34091 4.35455 8.7 4.56364 8.1V5.50909H1.16364C0.490909 6.85909 0.109091 8.38636 0.109091 10C0.109091 11.6136 0.490909 13.1409 1.16364 14.4909L4.56364 11.9Z" fill="#FBBC05"/>
        <path d="M10.2 3.97727C11.4727 3.97727 12.6136 4.40909 13.5091 5.25909L16.4364 2.33182C15.1591 1.14545 12.8955 0 10.2 0C6.24545 0 2.76364 2.34091 1.16364 5.50909L4.56364 8.1C5.38636 5.73636 7.59545 3.97727 10.2 3.97727Z" fill="#EA4335"/>
      </svg>
      {text}
    </button>
  );
};

export default GoogleSignInButton;